import { gql } from '@apollo/client'

export const USER_NOTIFICATIONS_MANAGE = gql`
  mutation userNotificationsManage($allowNotify: Boolean!) {
    userNotificationsManage(allowNotify: $allowNotify)
  }
`
